import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { LivreurCommandesComponent } from './commandes/livreur-commandes.component';
import { NiveauxLivreurComponent } from './niveaux/niveaux-livreur.component';
import { LivreurBilanComponent } from './mon-bilan/livreur-bilan.component';
import { LivreurFichesPaieComponent } from './fiches-paie/livreur-fiches-paie.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    LivreurCommandesComponent,
    NiveauxLivreurComponent,
    LivreurBilanComponent,
    LivreurFichesPaieComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatTooltipModule
  ]
})
export class LivreurModule {}
